// extracted by mini-css-extract-plugin
export default {"imageWrapper":"mF-z","hovered":"nF-z","hoverImage":"oF-z","mainImage":"pF-z","imageNoBackground":"qF-z","fullSizeImage":"rF-z"};